import React from 'react';
import { Spin } from 'antd';
import { IntlMessages } from '@/components';
import styles from './AppLoader.module.css';

const AppLoader = () => {
  return (
    <div className={styles.wrapper}>
      <Spin description={<IntlMessages id="ui-general-loading" />} />
    </div>
  );
};

export default AppLoader;
